import { Button, Divider, Form, Input, message, Modal, Typography, Upload, Select, InputNumber } from 'antd';
import React, { Component } from 'react';
import { AiOutlineCloudUpload } from 'react-icons/ai';
import { countries, themeColor } from '../../constants';

const { TextArea } = Input
const { Text } = Typography
const { Option } = Select;


class NewBOModal extends Component {
    render() {
        return (
            <div>
                <Modal
                    open={this.props.showNewBOModal}
                    title="Add a new Beneficial Owner"
                    // onOk={handleOk}
                    maskClosable={false}
                    onCancel={this.props.triggerShowNewBOModal}
                    footer={null}
                    destroyOnClose={true}
                    width={800}
                >
                    <Form
                        layout='horizontal'
                        name="newBOForm"
                        labelWrap={true}
                        labelAlign={'left'}
                        labelCol={{ span: 8 }}
                        // wrapperCol={{ span: 16 }}
                        initialValues={{ remember: true }}
                        onFinish={this.props.addNewBO}
                        // onFinishFailed={onFinishFailed}
                        autoComplete="off"
                        style={{ width: '100%', paddingLeft: 9 }}
                        colon={false}
                    >
                        <Form.Item
                            name='newBOSurname'
                            label={
                                <Text strong>
                                    Surname
                                </Text>
                            }
                            rules={[{ required: true, message: 'Please enter your Surname!' }]}
                        >
                            <Input autoFocus placeholder="Enter your Surname" />
                        </Form.Item>
                        <Form.Item
                            name='newBOFirstName'
                            label={
                                <Text strong>
                                    First Name
                                </Text>
                            }
                            rules={[{ required: true, message: 'Please enter your First Name!' }]}
                        >
                            <Input autoFocus placeholder="Enter your First Name" />
                        </Form.Item>
                        <Form.Item
                            name='newBONIC'
                            label={
                                <Text strong>
                                    NIC/Passport No.
                                </Text>
                            }
                            rules={[{ required: true, message: 'Please enter your NIC No.!' }]}
                        >
                            <Input placeholder="Enter NIC/Passport No." />
                        </Form.Item>
                        <Form.Item
                            name='newBONICProof'
                            label={
                                <Text strong>
                                    Upload NIC
                                    <br />
                                    <span style={{ fontSize: 13 }}>
                                        (Max 3 documents)
                                    </span>
                                </Text>
                            }
                            rules={[{ required: true, message: 'Please upload a picture of your NIC!' }]}

                        >
                            <Upload
                                name='file'
                                action={process.env.REACT_APP_API + '/api/upload/attachment/'}
                                accept=".png, .jpg, .jpeg, .pdf"
                                maxCount={3}
                                onChange={(info) => {
                                    if (info.file.status !== 'uploading') {
                                        console.log(info.file, info.fileList);
                                    }

                                    if (info.file.status === 'done') {
                                        message.success(`${info.file.name} file uploaded successfully`);
                                    } else if (info.file.status === 'error') {
                                        message.error(`${info.file.name} file upload failed.`);
                                    }
                                }}
                            >
                                <Button icon={<AiOutlineCloudUpload />}>Click to Upload</Button>
                            </Upload>
                        </Form.Item>
                        <Form.Item
                            name='newBONationality'
                            label={
                                <Text strong>
                                    Nationality
                                </Text>
                            }
                            rules={[{ required: true, message: 'Please choose your nationality!' }]}
                        >
                            <Select
                                placeholder="Select nationality"
                                // onChange={this.onGenderChange}
                                allowClear
                                showSearch
                            >
                                {countries.map((country, index) => {
                                    return (
                                        <Option key={index} value={country.name}>{country.name}</Option>
                                    )
                                })}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            name='newBOAddress'
                            label={
                                <Text strong>
                                    Permanent Address
                                </Text>
                            }
                            rules={[{ required: true, message: 'Please enter your current address!' }]}
                        >
                            <TextArea placeholder="Enter Address" />
                        </Form.Item>
                        <Form.Item
                            name='newBOInterestPercent'
                            label={
                                <Text strong>
                                    CONTROLLING OWNERSHIP INTEREST (%)
                                </Text>
                            }
                            initialValue={!this.props.isDisablePercentageInterest ? 0.01 : ''}
                        // rules={[{ required: !this.props.isDisablePercentageInterest, message: 'Please enter percentage interest!' }]}
                        >
                            <InputNumber
                                defaultValue={0.01}
                                value={0.01}
                                disabled={this.props.isDisablePercentageInterest}
                                min={0.01}
                                step={0.01}
                                // type='number'
                                max={100}
                                formatter={(value) => `${value}%`}
                                parser={(value) => value.replace('%', '')}
                            />

                        </Form.Item>
                        <Form.Item
                            name='newBOAddressProof'
                            label={
                                <Text strong>
                                    Upload Proof of Address
                                    <br />
                                    <span style={{ fontSize: 13 }}>
                                        (Max 3 documents)
                                    </span>
                                </Text>
                            }
                            rules={[{ required: true, message: 'Please upload a proof of address!' }]}
                        >
                            <Upload
                                name='file'
                                action={process.env.REACT_APP_API + '/api/upload/attachment/'}
                                accept=".png, .jpg, .jpeg, .pdf"
                                maxCount={3}
                                onChange={(info) => {
                                    if (info.file.status !== 'uploading') {
                                        console.log(info.file, info.fileList);
                                    }

                                    if (info.file.status === 'done') {
                                        message.success(`${info.file.name} file uploaded successfully`);
                                    } else if (info.file.status === 'error') {
                                        message.error(`${info.file.name} file upload failed.`);
                                    }
                                }}
                            >
                                <Button icon={<AiOutlineCloudUpload />}>Click to Upload</Button>
                            </Upload>
                        </Form.Item>
                        <Divider />
                        <div style={{ textAlign: 'right' }}>

                            {/* <Form.Item> */}
                            <Button
                                key="back"
                                onClick={this.props.triggerShowNewBOModal}
                                style={{ marginRight: 10 }}
                            >
                                Cancel
                            </Button>
                            <Button
                                key="submit"
                                className='buttonColorChange'
                                style={{ backgroundColor: themeColor }}
                                type="primary"
                                htmlType="submit"
                                loading={this.props.isAddingNewBoLoader}
                            >
                                Add BO
                            </Button>
                            {/* </Form.Item> */}
                        </div>

                    </Form>
                </Modal>

            </div >
        );
    }
}

export default NewBOModal;